var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4585 7.0451C32.0781 -2.33526 16.8792 -2.35037 7.51698 7.01187C-1.8513 16.3832 -1.84224 31.576 7.54417 40.9564C16.9245 50.3368 32.1265 50.3489 41.4857 40.9866C50.8509 31.6244 50.8419 16.4255 41.4585 7.0451ZM29.3652 34.0956L24.2657 28.9961L19.1662 34.0956C17.0846 36.1771 15.5197 37.9897 13.0364 35.5095C10.5592 33.0292 12.3627 31.4643 14.4533 29.3797L19.5528 24.2832L14.4533 19.1837C12.3688 17.1022 10.5592 15.5373 13.0364 13.054C15.5197 10.5767 17.0846 12.3863 19.1662 14.4708L24.2657 19.5643L29.3652 14.4708C31.4497 12.3893 33.0056 10.5737 35.4889 13.054C37.9722 15.5373 36.1626 17.1022 34.0781 19.1837L28.9785 24.2802L34.0781 29.3767C36.1596 31.4643 37.9722 33.0292 35.4889 35.5095C33.0116 37.9897 31.4497 36.1771 29.3652 34.0956Z",
    fill: "#F34E4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegectIcon);
export default __webpack_public_path__ + "static/media/RegectIcon.f4b0c4dc853fceb0e2099050e9745300.svg";
export { ForwardRef as ReactComponent };